module.exports = __webpack_public_path__ + "static/media/Screenshot10.3b2bbe0a.jpg";